import Vue from 'vue'
import App from './App.vue'
import './plugins/globals'
import vuetify from './plugins/vuetify'
import router from './router'
import pinia from './stores'

Vue.config.productionTip = false
Vue.config.devtools = false

// Applied before mount so the right look is active on first paint for users who've opted
// into v2 - mirrors the dark-mode boot read in @core/preset/preset/index.js.
if (localStorage.getItem('schooldash-ui-version') === 'v2') {
  document.documentElement.classList.add('ui-v2')
}

new Vue({
  router,
  pinia,
  vuetify,

  render: h => h(App),
}).$mount('#app')
